import { FlightSearchSummary } from "@/types/flights/flight-search-summary"

import { baseApi } from "./base-api"

interface FlightSearchSummaryArgs {
  messageId: number
  shareCode?: string
}

export const messagesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFlightSearchSummary: builder.query<
      FlightSearchSummary,
      FlightSearchSummaryArgs
    >({
      query: (args) => {
        const params = new URLSearchParams()
        if (args.shareCode) {
          params.set("share_code", args.shareCode)
        }
        const query = params.toString()
        const url = `api/messages/${args.messageId}/flight_search_summary${query ? `?${query}` : ""}`
        return { url }
      },
      transformResponse: (response: {
        flight_search_summary: FlightSearchSummary
      }) => response.flight_search_summary,
      providesTags: ["FlightSearchSummary"],
      keepUnusedDataFor: 1800,
    }),
  }),
})

export const { useGetFlightSearchSummaryQuery } = messagesApi
